var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeadline32Filled = function SvgIconHeadline32Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 16.534H7.334V18.8h17.333v-2.266ZM24.667 22.487H7.334v2.267h17.333v-2.267ZM22.734 7.247H9.267A1.933 1.933 0 0 0 7.334 9.18v2.4c0 1.068.866 1.934 1.933 1.934h13.467a1.933 1.933 0 0 0 1.933-1.934v-2.4a1.933 1.933 0 0 0-1.933-1.933Z",
    fill: "current"
  })));
};
export default SvgIconHeadline32Filled;